import React from "react";

import styled from "styled-components/macro";

import { useSignups } from "Signups/state";
import { motion } from "framer-motion";

import { colors } from "UI/colors";

export default function ErrorMessage() {
  const [state] = useSignups();
  const { showingSignupsListHolder } = state;

  let width = window.innerWidth;

  return (
    <Container>
      <Message
        animate={{
          margin:
            showingSignupsListHolder &&
            ((width > 725 && width < 840) || width > 1060)
              ? "16px 36px 16px 340px"
              : "16px 36px",
        }}
      >
        <div>
          <Icon className="fas fa-exclamation-triangle" />
        </div>
        <Line1>{`Hmmm... This Signup could not be found.`}</Line1>
        <Line2>
          Please select a different Signup, or contact{" "}
          <a href="mailto:help@flocknote.com" target="_blank" rel="noreferrer">
            help@flocknote.com
          </a>
        </Line2>
      </Message>
    </Container>
  );
}

const Container = styled.div`
  display: grid;
  place-items: center;
  width: 100%;
  transition: all 0.3s ease-in-out;
`;

const Message = styled(motion.div)`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 24px;
  max-width: 500px;

  text-align: center;
  font-weight: 400;
  padding: 36px;
  border-radius: 16px;
  box-shadow: 0 0 8px 0 rgba(0, 0, 0, 0.2);

  a,
  a:visited {
    color: ${colors.fnBlue};
  }

  @media (max-width: 1024px) {
    font-size: 16px;
    max-width: 400px;
  }
`;

const Line1 = styled.div`
  font-size: 24px;
`;

const Line2 = styled.div`
  line-height: 1.5;
  font-size: 19px;
`;

const Icon = styled.i`
  font-size: 48px;
  color: ${colors.fnBlue};

  @media (max-width: 1024px) {
    font-size: 32px;
  }
`;
